<template>
    <svg width="19" height="16" viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M18.399 3.35594H0.822998V15.075H18.399V3.35594ZM9.611 12.984C8.87921 12.984 8.16385 12.763 7.55539 12.3489C6.94693 11.9348 6.47269 11.3462 6.19264 10.6576C5.9126 9.96902 5.83933 9.21129 5.98209 8.48027C6.12486 7.74925 6.47725 7.07776 6.9947 6.55073C7.51216 6.02369 8.17143 5.66477 8.88916 5.51936C9.60689 5.37396 10.3508 5.44859 11.0269 5.73382C11.703 6.01905 12.2809 6.50207 12.6874 7.1218C13.094 7.74152 13.311 8.47013 13.311 9.21547C13.311 10.2149 12.9212 11.1735 12.2273 11.8802C11.5334 12.587 10.5923 12.984 9.611 12.984ZM7.532 0.327881H11.689L13.056 2.56862H6.165L7.532 0.327881ZM11.832 9.21547C11.832 9.66268 11.7018 10.0998 11.4579 10.4717C11.2139 10.8435 10.8672 11.1333 10.4616 11.3045C10.0559 11.4756 9.60954 11.5204 9.1789 11.4331C8.74826 11.3459 8.35269 11.1305 8.04222 10.8143C7.73175 10.4981 7.52031 10.0952 7.43465 9.65659C7.349 9.21798 7.39296 8.76335 7.56099 8.35018C7.72901 7.93702 8.01356 7.58388 8.37863 7.33543C8.74371 7.08697 9.17292 6.95436 9.612 6.95436C10.2006 6.95463 10.765 7.19297 11.1811 7.61699C11.5972 8.041 11.832 8.61596 11.832 9.21547Z"
            :fill="color || '#ED5023'" />
    </svg>
</template>

<script>
export default {
    name: "Camera",
    props: ["color"],
};
</script>




// WEBPACK FOOTER //
// src/components/V2/svg/components/Camera.vue